module.exports = __webpack_public_path__ + "img/not-sure.2a9d052a.svg";